// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { ShapeElement } from './ShapeElement';
/**
 * 图表图形 实体类
 * 定义一个图标，即画布，存放所有的图形，一个图形代表一个组件
 */
export abstract class BaseDiagramShape extends ShapeElement {
  /** 是否锁定 : 锁定的图形不能进行任何的编辑操作 */
  private _isLocked: boolean;

  /** 设置：是否锁定 */
  public get isLocked() {
    return this._isLocked;
  }

  /** 获取：是否锁定 */
  public set isLocked(value: boolean) {
    this._isLocked = value;
  }

  /** 当前组件 : 当前组件 */
  private _componentId: string;

  /** 设置：当前组件 */
  public get componentId() {
    return this._componentId;
  }

  /** 获取：当前组件 */
  public set componentId(value: string) {
    this._componentId = value;
  }

  /** 内容 : JSON格式存储的内容 */
  private _contentJson: string;

  /** 设置：内容 */
  public get contentJson() {
    return this._contentJson;
  }

  /** 获取：内容 */
  public set contentJson(value: string) {
    this._contentJson = value;
  }

  /** 组件类型 : 组件类型 */
  private _componentType: string;

  /** 设置：组件类型 */
  public get componentType() {
    return this._componentType;
  }

  /** 获取：组件类型 */
  public set componentType(value: string) {
    this._componentType = value;
  }

  constructor() {
    super();
    this._isLocked = false;
    this._componentId = '';
    this._contentJson = '';
    this._componentType = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BaseDiagramShape, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isLocked = element.isLocked;
      this.componentId = element.componentId;
      this.contentJson = element.contentJson;
      this.componentType = element.componentType;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isLocked = json.IsLocked;
    this.componentId = json.ComponentId;
    this.contentJson = json.ContentJson;
    this.componentType = json.ComponentType;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsLocked = this.isLocked;
    json.ComponentId = this.componentId;
    json.ContentJson = this.contentJson;
    json.ComponentType = this.componentType;
  }
}
